import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useSelector } from 'react-redux';
import { Pagination } from 'antd';
import PackageTable from './Common/PackageTable';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import SelectList from './Common/SelectList';
import AlertMessage from './Common/AlertMessage';
import SearchBtn from './Common/SearchBtn';
import ConvertButtons from './Common/ConvertButtons';

const AllPackages = ({ isShow, setIsShow }) => {
    const packagetable = [
        {
            Sno: 1,
            name: 'Weight Loss',
            pGroup: 'Fitness',
            period: ' yearly',
            days: 30 * 12,
            fees: '6000'
        },
        {
            Sno: 2,
            name: 'Weight Gain',
            pGroup: 'Fitness',
            period: 'half yearly',
            days: 30 * 6,
            fees: '2500'
        },
        {
            Sno: 3,
            name: 'Weight Loss',
            pGroup: 'Fitness',
            period: 'monthly',
            days: 30,
            fees: '6000'
        },
        {
            Sno: 4,
            name: 'Weight Gain',
            pGroup: 'Fitness',
            period: 'quarterly',
            days: 90,
            fees: '2500'
        }
    ];
    const [data, setData] = useState(packagetable);
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const dataRef = React.createRef();
    const { alert } = useSelector(state => state.alert);

    const isDelete = (item) => {
        const newData = data.filter(e => { return e.Sno !== item.Sno });
        setData(newData)
    };

    const handleDelete = (item) => {
        confirmAlert({
            message: "Are you sure you want to Delete?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => isDelete(item)
                },
                {
                    label: 'Cancel',
                    onClick: () => null
                }
            ],
            overlayClassName: "react-confirm-alert-overlay react-confirm-alert-body"
        })
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        } else if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <div className='page_first_div '>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div'>
                <p className='page_topic inline-block'>All packages</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/package/" className='link block text-white text-sm'>
                        <i className="fa-solid fa-square-plus mr-1"></i>
                        Add
                    </Link>
                </div>
                <section className='page_section min-h-[23rem]'>

                    {/* showing success message */}
                    {alert && <AlertMessage />}

                    {/* selectors and search bars */}
                    <form className='flex flex-col justify-center px-4 xsm:px-8 lg:flex-row 2xl:justify-start items-center flex-wrap gap-4 py-4 '>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Package Group--</option>
                                <option value="Fitness" >Fitness</option>
                                <option value="BuildUp">BuildUp</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select Package Period--</option>
                                <option value="HALF YEARLY" >HALF YEARLY</option>
                                <option value="MONTHLY">MONTHLY</option>
                                <option value="YEARLY">YEARLY</option>
                                <option value="QUARTERLY">QUARTERLY</option>
                            </select>
                        </div>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100">
                                <option value=''>--Select status--</option>
                                <option value="Active" >Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                        <SearchBtn
                            setSearchTerm={setSearchTerm}
                        />
                    </form>

                    {/* show option and convert buttons */}
                    <div className='pt-2 flex flex-col gap-4 justify-center md:justify-between px-4 xsm:px-8 md:flex-row'>
                        <SelectList
                            setPostPerPage={setPostPerPage}
                            data={data}
                        />
                        <ConvertButtons
                            data={data}
                            ref={dataRef}
                        />
                    </div>
                    {/* all packages table data details */}
                    <PackageTable
                        data={currentPost}
                        setData={setData}
                        sortData={data}
                        onDelete={handleDelete}
                        searchTerm={searchTerm}
                        ref={dataRef}
                    />

                    {/* Paginations and table length */}
                    <div className='px-4 xsm:px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
                        <p className='text-sm text-gray-800'>
                            showing {page} to {currentPost.length} of {data.length} entries
                        </p>
                        <Pagination
                            total={data.length}
                            onChange={value => setPage(value)}
                            itemRender={itemRender}
                            pageSize={postPerPage}
                            current={page}
                        />
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AllPackages;